import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useAccounts({
  enabled = true,
}: {
  enabled?: boolean;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['metrics/account'], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: 'metrics/account',
      });
      return res;
    },
    enabled,
    retry: false,
  });
}
